import clsx from 'clsx';
import { forwardRef } from 'react';

// Add this type declaration at the top of the file
interface WebpackRequireContext {
  keys(): string[];
  (id: string): string;
  <T>(id: string): T;
}

declare const require: {
  context: (
    directory: string,
    useSubdirectories: boolean,
    regExp: RegExp,
  ) => WebpackRequireContext;
};

// Update the path to match your actual SVG files location
const requireSvgs = require.context('../../assets/svg', false, /\.svg$/);

requireSvgs.keys().forEach((key) => requireSvgs(key));

export type IconName =
  | 'checkbox'
  | 'sun'
  | 'sunset'
  | 'magic'
  | 'timer'
  | 'clipboardcopy'
  | 'arrowup'
  | 'arrowdown'
  | 'check'
  | 'cross'
  | 'target'
  | 'link'
  | 'meeting'
  | 'confetti'
  | 'warning';

interface IconProps {
  name: IconName;
  className?: string;
  color?: string;
  rotate?: 0 | 90 | 180 | 270;
  animate?: 'spin' | 'pulse';
  title?: string;
  onClick?: () => void;
}

export const Icon = forwardRef<SVGSVGElement, IconProps>(
  (
    { name, className, color, rotate = 0, animate, title, onClick, ...props },
    ref,
  ): JSX.Element => {
    return (
      <svg
        ref={ref}
        className={clsx(
          'flex flex-shrink-0 mb-0 p-0',
          {
            'w-5 h-5': !className?.includes('w-') && !className?.includes('h-'),
            'rotate-90': rotate === 90,
            'rotate-180': rotate === 180,
            '-rotate-90': rotate === 270,
          },
          animate === 'spin' && 'animate-spin',
          animate === 'pulse' && 'animate-pulse',
          '[&_*]:fill-current',
          className,
        )}
        onClick={onClick}
        style={{ color }}
        role={title ? 'img' : 'presentation'}
        aria-label={title}
        {...props}
      >
        {title && <title>{title}</title>}
        <use href={`#icon-${name}`} />
      </svg>
    );
  },
);

Icon.displayName = 'Icon';
